"use client"
import React from 'react';
import Link from 'next/link';
import { useController } from 'react-hook-form';

import { Input } from '@/stories/components/Form/Input/Input';
import { Grid } from '@/stories/organisms/Grid/Grid';
import { Checkbox } from '@/stories/components/Form/Checkbox/Checkbox';
import { getRoute } from '@/utils/utils';

export const CoordStep = ({nom}: {nom: string}) => {

  const {
    field: firstName,
    fieldState: { error: firstNameError },
  } = useController({
    name: 'firstName',
  })

  const {
    field: lastName,
    fieldState: { error: lastNameError },
  } = useController({
    name: 'lastName',
  })

  const {
    field: email,
    fieldState: { error: emailError },
  } = useController({
    name: 'email',
  })

  const {
    field: phone,
    fieldState: { error: phoneError },
  } = useController({
    name: 'phone',
  })

  const {
    field: consent,
    fieldState: { error: consentError },
  } = useController({
    name: 'consent',
  })

  return (
    <>
      <Grid nbCols={2}>
        <Input
          value={firstName.value || ''}
          setValue={(value: string) => firstName.onChange(value)}
          errorText={firstNameError?.message}
          variant='secondary'
          label='Prénom'
          id='firstName'
          icon='pencil'
          placeholder='John'
          required/>
        <Input
          value={lastName.value || ''}
          setValue={(value: string) => lastName.onChange(value)}
          errorText={lastNameError?.message}
          variant='secondary'
          label='Nom'
          id='lastName'
          icon='pencil'
          placeholder='DOE'
          required/>
      </Grid>
      <Grid nbCols={2}>
        <Input
          value={email.value || ''}
          setValue={(value: string) => email.onChange(value)}
          errorText={emailError?.message}
          type='email'
          variant='secondary'
          label='Email'
          id='email'
          icon='envelope'
          placeholder='john.doe@gmail.com'
          required/>
        <Input
          value={phone.value || ''}
          setValue={(value: string) => phone.onChange(value)}
          errorText={phoneError?.message}
          type='phone'
          variant='secondary'
          label='Téléphone'
          id='phone'
          icon='phone'
          placeholder='06 XX XX XX XX'
          required/>
      </Grid>
      <Checkbox
        onChange={() => consent.onChange(!consent.value)}
        checked={consent.value || false}
        errorText={consentError?.message}
        variant='secondary'
        id='data'
        label={
          <>
            J’accepte que mes données soient utilisées par {nom} pour répondre à ma demande, conformément à la <Link href={getRoute({key: 'privacy-policy'})}>Politique de confidentialité</Link>.
          </>
        }/>
    </>
  )
};